// extracted by mini-css-extract-plugin
export default {"mailInfoContainer":"InfoSet_mailInfoContainer__42XFe","infoTitle":"InfoSet_infoTitle__F6OxX","data":"InfoSet_data__3mqu9"};